var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { MediaExplorerPopover } from '../../../containers/MediaExplorerFromUIKit/MediaExplorerPopover';
import { changeAppNameAndLogo } from '@project/store/createAppFlow/actions';
import { IMAGE_FILES } from '@project/containers/MediaExplorer/constants';
import { AppEditTypes } from '@project/store/createAppFlow/models';
import { MediaContentImage, MediaEditBoxWrapper } from '../styles';
import defaultAppIcon from '../../../images/default-app-icon.png';
import { useParams } from 'react-router-dom';
var AppIconEdit = function (_a) {
    var icon = _a.icon, onChange = _a.onChange;
    var dispatch = useDispatch();
    var params = useParams();
    var _b = useState(false), isImageHovered = _b[0], setIsImageHovered = _b[1];
    var _c = useState(icon), appIcon = _c[0], setAppIcon = _c[1];
    useEffect(function () {
        setAppIcon(icon);
    }, [icon]);
    var handleFileSelect = function (file) {
        if (file) {
            setAppIcon((file === null || file === void 0 ? void 0 : file.url) || null);
            onChange(file === null || file === void 0 ? void 0 : file.url);
            setIsImageHovered(false);
            dispatch(changeAppNameAndLogo(file === null || file === void 0 ? void 0 : file.url, AppEditTypes.LOGO));
        }
    };
    return (_jsx(MediaEditBoxWrapper, __assign({ onMouseLeave: function () { return setIsImageHovered(false); }, onMouseEnter: function () { return setIsImageHovered(true); } }, { children: _jsx(MediaExplorerPopover, __assign({ scope: "org:".concat(params === null || params === void 0 ? void 0 : params.organizationId), baseUrl: process.env.API_BASE_URL, aptVersion: process.env.APT_VERSION, mediaBucketURL: process.env.MEDIA_BUCKET_URL, iconBucketURL: process.env.ICON_BUCKET_URL, fileBucketURL: process.env.FILE_BUCKET_URL, onSelectFile: handleFileSelect, selectedFile: true, acceptedTypes: IMAGE_FILES, hideClearButton: true, imageHover: isImageHovered }, { children: _jsx(MediaContentImage, { src: appIcon ? appIcon : defaultAppIcon, alt: "" }) })) })));
};
export default AppIconEdit;
